import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import {
    SET_SELECTED_ROWS,
    ALL_PROPOSED_REGULATIONS_RECEIVED,
    RegulationListViewTypes,
    RegulationListViewState,
    SET_REGULATION_NAME,
    DATA_FOR_FILTERS_RECEIVED,
    SET_PROPOSED_CHANGES_FILTER_PARAMS,
    TOGGLE_ACTION_PERFORMED,
    GET_ALL_PROPOSED_REGULATIONS,
    SELECTED_REGULATION_COLUMNS,
    FILTER_DATA_FOR_SENSOR_IDS_RECEIVED
} from "../../actions/regulation/Listview/types";

import { defaultGetResponse } from "../../interfaces/ActionReducer/GetMethod/GetResponse";
const initialState: RegulationListViewState = {
    selectedRowIds: [],
    isPublished: [],
    parentLinkIds: [],
    curbLinkId: [],
    allProposedRegulations: defaultGetResponse,
    isAllProposedRegulationsFetching: false,
    setRegulationName: "",
    filtersData: [],
    proposedChangesParams: {},
    actionPerformed: false,
    actionsData: [],
    batchIds: [],
    selectedColumns: [],
    sensorIdsFilterData: []
};
const regulationListView = (
    state = initialState,
    action: RegulationListViewTypes
): RegulationListViewState => {
    switch (action.type) {
        case SET_SELECTED_ROWS: {
            return {
                ...state,
                selectedRowIds: action.payload.selectedRows,
                isPublished: action.payload.isPublished,
                parentLinkIds: action.payload.parentLinkIds,
                curbLinkId: action.payload.curbLinkId,
                actionsData: action.payload.actionsData,
                batchIds: action.payload.batchIds
            };
        }

        // Updating the state in the redux-store.
        case SET_REGULATION_NAME: {
            return {
                ...state,
                setRegulationName: action.payload.regulationName
            };
        }

        case GET_ALL_PROPOSED_REGULATIONS: {
            return {
                ...state,
                isAllProposedRegulationsFetching: true
            };
        }

        case ALL_PROPOSED_REGULATIONS_RECEIVED: {
            return {
                ...state,
                isAllProposedRegulationsFetching: false,
                allProposedRegulations: action.payload.allProposedRegulationsReceived
            };
        }

        case SELECTED_REGULATION_COLUMNS: {
            return {
                ...state,
                selectedColumns: action.payload.selectedColumns
            };
        }

        case DATA_FOR_FILTERS_RECEIVED: {
            return {
                ...state,
                filtersData: action.payload.data
            };
        }
        case FILTER_DATA_FOR_SENSOR_IDS_RECEIVED: {
            return {
                ...state,
                sensorIdsFilterData: action.payload.data
            };
        }
        case SET_PROPOSED_CHANGES_FILTER_PARAMS: {
            return {
                ...state,
                proposedChangesParams: action.payload.params
            };
        }
        case TOGGLE_ACTION_PERFORMED: {
            return {
                ...state,
                actionPerformed: !state.actionPerformed
            };
        }
        case RESET_STATE: {
            return {
                ...initialState
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
};

export default regulationListView;
